import { Component, OnChanges, OnInit, Renderer2 } from '@angular/core';
import { ReplyAbstractComponent } from '@app/shared/components/reply/reply-abstract.component';
import { DomSanitizer } from '@angular/platform-browser';
import { BalanceHistoryService } from '@app/core/account/balance-history.service';
import { SocketService } from '@app/core/socket.service';

const MersenneTwister = require('mersennetwister');

interface Field {
  value: number;
  color: string;
  index?: number;
}

@Component({
  selector: 'app-reply-roulette',
  template: `
    <div class="roulette-wheel-wrap">
      <div class="roulette-wheel" [ngStyle]="{ transform: 'rotateZ(-' + deg + 'deg)' }">
        <div class="roulette-normal-wheel" [class.bonus]="bonusWheel"></div>
        <div class="roulette-borders"></div>
        <div class="roulette-center"></div>
      </div>
      <div class="roulette-pointer"></div>
    </div>
  `,
  styleUrls: ['./reply-roulette.component.scss'],
})
export class ReplyRouletteComponent extends ReplyAbstractComponent implements OnChanges {
  data: any = null;

  field: Field;
  deg: number = 0;

  fields: Field[] = [];
  bonusWheel: boolean = false;

  constructor(
    protected socket: SocketService,
    private sanitizer: DomSanitizer,
    private renderer: Renderer2,
    protected balanceHistory: BalanceHistoryService
  ) {
    super(socket, balanceHistory);

    this.fields = [
      { value: 11, color: 'black' },
      { value: 4, color: 'red' },
      { value: 17, color: 'black' },
      { value: 10, color: 'red' },
      { value: 19, color: 'black' },
      { value: 2, color: 'red' },
      { value: 13, color: 'black' },
      { value: 21, color: 'bonus' },
      { value: 8, color: 'red' },
      { value: 3, color: 'black' },
      { value: 18, color: 'red' },
      { value: 5, color: 'black' },
      { value: 12, color: 'red' },
      { value: 15, color: 'black' },
      { value: 6, color: 'red' },
      { value: 9, color: 'black' },
      { value: 16, color: 'red' },
      { value: 1, color: 'black' },
      { value: 0, color: 'skull' },
      { value: 20, color: 'red' },
      { value: 7, color: 'black' },
      { value: 14, color: 'red' },
    ];
  }

  // specified game
  protected initialize(data: any) {
    if (data) {
      if (data.game !== 'roulette') {
        this._error = true;
        return;
      }
      this.data = data.gameData;
      this._loading = false;
    }

    // const randomNumber: number = this.generateRandomNumber(this.playerSeed, this.serverSeed, 22);
    // this.field = this.searchField(randomNumber);
    // this.deg = (360 / this.fields.length) * this.field.index;

    this.generateGame();
  }

  // not specified game
  protected generateGame() {
    let randomNumber: number = this.generateRandomNumber(this.playerSeed, this.serverSeed, 22);
    this.field = this.searchField(randomNumber);
    if (this.field.color === 'bonus') {
      this.bonusWheel = true;
      randomNumber = this.generateRandomNumber(this.serverSeed, this.playerSeed, 11);
      this.deg = (360 / 11) * randomNumber;
    } else {
      this.bonusWheel = false;
      this.deg = (360 / this.fields.length) * this.field.index;
    }

    this._loading = false;
  }

  private generateRandomNumber(clientSeed: string, serverSeed: string, toNumber: number): number {
    clientSeed = clientSeed.replace('0x', '');
    serverSeed = serverSeed.replace('0x', '');
    const clSeedSplitted = clientSeed.match(/.{1,6}/g);
    const srvSeedSplitted = serverSeed.match(/.{1,6}/g);
    const seedsCombined = clSeedSplitted.concat(srvSeedSplitted);
    for (let i = 0; i < seedsCombined.length; i++) {
      seedsCombined[i.toString()] = parseInt(seedsCombined[i], 16);
    }

    const mt = new MersenneTwister();
    mt.seedArray(seedsCombined);

    return mt.int() % toNumber;
  }

  private searchField(randomNumber: number): Field {
    const obj: Field = this.fields.find((field: any, index: number) => {
      if (field.value === randomNumber) {
        field.index = index;
        return field;
      }
    });
    return obj;
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/shared/components/reply/reply-roulette.component.ts